export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11433.2779b6bb.jpg";